import { Fragment, useEffect } from "react";
import BackLink from "../../components/atoms/BackLink/index";
import Loader from "../../components/atoms/Loader";
import KarteItem from "../../components/features/KarteItem";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import { AuthenticateRouterProps } from "../../hocs/enhanceAuthenticatedPage";
import enhanceStudentsPage from "../../hocs/enhanceStudentsPage";
import { useFetchKarte } from "../../hooks/http/useFetchKarte";
import { useQueryError } from "../../hooks/http/useQueryError";
import StudentInterface from "../../interfaces/StudentInterface";

interface Props
  extends WithRouterProps<AuthenticateRouterProps & { karteId: string }>,
    OutletContextProps {
  student: StudentInterface;
}

const StudentsKartePage = (props: Props) => {
  const { student, params, setActiveMenu } = props;

  useEffect(() => {
    setActiveMenu("karte");
  }, []);

  const {
    data: karteData,
    isPending,
    error,
  } = useFetchKarte({
    studentId: student.id,
    karteId: params.karteId,
  });
  useQueryError(error);

  if (isPending || !karteData) {
    return <Loader loading />;
  }

  return (
    <Fragment>
      <BackLink>戻る</BackLink>
      <KarteItem karte={karteData} section={student.section} />
    </Fragment>
  );
};

export default enhanceStudentsPage(StudentsKartePage, {
  title: "カルテ",
});
